export default __webpack_public_path__ + "static/media/16.95e91097.png";